"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.JsonRpcProvider = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _events = require("events");

var _jsonrpcUtils = require("@walletconnect/jsonrpc-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var JsonRpcProvider = /*#__PURE__*/function (_IJsonRpcProvider) {
  _inherits(JsonRpcProvider, _IJsonRpcProvider);

  var _super = _createSuper(JsonRpcProvider);

  function JsonRpcProvider(connection) {
    var _this;

    _classCallCheck(this, JsonRpcProvider);

    _this = _super.call(this, connection);
    _this.events = new _events.EventEmitter();
    _this.hasRegisteredEventListeners = false;
    _this.connection = _this.setConnection(connection);

    if (_this.connection.connected) {
      _this.registerEventListeners();
    }

    return _this;
  }

  _createClass(JsonRpcProvider, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var connection,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                connection = _args.length > 0 && _args[0] !== undefined ? _args[0] : this.connection;
                _context.next = 3;
                return this.open(connection);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connect() {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.close();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "on",
    value: function on(event, listener) {
      this.events.on(event, listener);
    }
  }, {
    key: "once",
    value: function once(event, listener) {
      this.events.once(event, listener);
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      this.events.off(event, listener);
    }
  }, {
    key: "removeListener",
    value: function removeListener(event, listener) {
      this.events.removeListener(event, listener);
    }
  }, {
    key: "request",
    value: function () {
      var _request2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_request, context) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.requestStrict((0, _jsonrpcUtils.formatJsonRpcRequest)(_request.method, _request.params || [], _request.id || (0, _jsonrpcUtils.getBigIntRpcId)().toString()), context));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function request(_x, _x2) {
        return _request2.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "requestStrict",
    value: function () {
      var _requestStrict = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee5(request, context) {
        var _this2 = this;

        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee4(resolve, reject) {
                    return _regenerator["default"].wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (_this2.connection.connected) {
                              _context4.next = 9;
                              break;
                            }

                            _context4.prev = 1;
                            _context4.next = 4;
                            return _this2.open();

                          case 4:
                            _context4.next = 9;
                            break;

                          case 6:
                            _context4.prev = 6;
                            _context4.t0 = _context4["catch"](1);
                            reject(_context4.t0);

                          case 9:
                            _this2.events.on("".concat(request.id), function (response) {
                              if ((0, _jsonrpcUtils.isJsonRpcError)(response)) {
                                reject(response.error);
                              } else {
                                resolve(response.result);
                              }
                            });

                            _context4.prev = 10;
                            _context4.next = 13;
                            return _this2.connection.send(request, context);

                          case 13:
                            _context4.next = 18;
                            break;

                          case 15:
                            _context4.prev = 15;
                            _context4.t1 = _context4["catch"](10);
                            reject(_context4.t1);

                          case 18:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, null, [[1, 6], [10, 15]]);
                  }));

                  return function (_x5, _x6) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function requestStrict(_x3, _x4) {
        return _requestStrict.apply(this, arguments);
      }

      return requestStrict;
    }()
  }, {
    key: "setConnection",
    value: function setConnection() {
      var connection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.connection;
      return connection;
    }
  }, {
    key: "onPayload",
    value: function onPayload(payload) {
      this.events.emit("payload", payload);

      if ((0, _jsonrpcUtils.isJsonRpcResponse)(payload)) {
        this.events.emit("".concat(payload.id), payload);
      } else {
        this.events.emit("message", {
          type: payload.method,
          data: payload.params
        });
      }
    }
  }, {
    key: "onClose",
    value: function onClose(event) {
      if (event && event.code === 3000) {
        this.events.emit("error", new Error("WebSocket connection closed abnormally with code: ".concat(event.code, " ").concat(event.reason ? "(".concat(event.reason, ")") : "")));
      }

      this.events.emit("disconnect");
    }
  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var connection,
            _args6 = arguments;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                connection = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : this.connection;

                if (!(this.connection === connection && this.connection.connected)) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return");

              case 3:
                if (this.connection.connected) this.close();

                if (!(typeof connection === "string")) {
                  _context6.next = 8;
                  break;
                }

                _context6.next = 7;
                return this.connection.open(connection);

              case 7:
                connection = this.connection;

              case 8:
                this.connection = this.setConnection(connection);
                _context6.next = 11;
                return this.connection.open();

              case 11:
                this.registerEventListeners();
                this.events.emit("connect");

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.connection.close();

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "registerEventListeners",
    value: function registerEventListeners() {
      var _this3 = this;

      if (this.hasRegisteredEventListeners) return;
      this.connection.on("payload", function (payload) {
        return _this3.onPayload(payload);
      });
      this.connection.on("close", function (event) {
        return _this3.onClose(event);
      });
      this.connection.on("error", function (error) {
        return _this3.events.emit("error", error);
      });
      this.connection.on("register_error", function (error) {
        return _this3.onClose();
      });
      this.hasRegisteredEventListeners = true;
    }
  }]);

  return JsonRpcProvider;
}(_jsonrpcUtils.IJsonRpcProvider);

exports.JsonRpcProvider = JsonRpcProvider;
var _default = JsonRpcProvider;
exports["default"] = _default;